import type { FC } from 'react';
import type { ProjectData, CaseStudyProps } from '../data-projects';

export const MedtechNotificationSystem: FC<ProjectData & CaseStudyProps> = ({ cta }) => {
  return (
    <>
      <section>
        <h3>15-minute notification delays risk €2M+ in healthcare staffing losses</h3>
        <h4>The Push for Change</h4>
        <p>
          A leading French healthcare staffing platform serves 400,000+ medical professionals, processing 7,000 daily shift assignments across hospitals and clinics. Each unfilled shift represents potential care disruption and revenue loss, making rapid notification delivery business-critical.
        </p>
        <p>
          The existing notification system delivered 3,000 messages per minute but experienced 15-minute delays during peak demand. For emergency staffing needs, these delays translated to unfilled shifts, overtime costs, and potential patient care gaps—estimated at €2M+ annually in lost efficiency.
        </p>
      </section>

      <section id="solution">
        <h3>30x throughput increase eliminates notification bottlenecks</h3>
        <h4>Shaping Solutions from Technology</h4>
        <p>
          System analysis revealed architectural constraints limiting message processing capacity and causing queue backups during high-demand periods. The notification infrastructure required complete redesign to handle healthcare's unpredictable surge patterns.
        </p>
        <p>
          Implementation involved rebuilding the notification engine with improved queue management, database optimization, and parallel processing capabilities. A phased migration strategy maintained 100% uptime while gradually transferring traffic to the new system, ensuring zero service disruption during the transition.
        </p>
      </section>

      <section id="results">
        <h3>87% faster notifications improve shift fill rates by 23%</h3>
        <h4>Delivering Lasting Results</h4>
        <p>
          The upgraded system delivers 90,000 notifications per minute—a 30x capacity increase—while reducing average delivery time from 15 minutes to 2 minutes. This performance improvement directly correlates to 23% faster shift fill rates during peak demand periods.
        </p>
        <p>
          Healthcare institutions now receive critical staffing notifications within seconds rather than minutes, enabling faster decision-making and reducing the risk of unfilled shifts. The platform can now handle 10x current user growth without performance degradation.
        </p>
      </section>

      {cta}
    </>
  );
};
